import React from 'react';

export const FieldLabel = ({ children, htmlFor, className = '' }) => (
  <label htmlFor={htmlFor} className={`text-label text-secondary block mb-2 ${className}`}>
    {children}
  </label>
);

export const EditorialToggle = ({ checked, onChange, label, description, id }) => (
  <div className="flex flex-wrap items-center justify-between gap-4 py-4">
    <div className="min-w-0 flex-1">
      <p className="text-body text-primary" id={id ? `${id}-label` : undefined}>
        {label}
      </p>
      {description && <p className="text-label text-secondary mt-0.5">{description}</p>}
    </div>
    <button
      type="button"
      role="switch"
      id={id}
      aria-checked={checked}
      aria-labelledby={id ? `${id}-label` : undefined}
      onClick={() => onChange(!checked)}
      className={`toggle-editorial ${checked ? 'toggle-editorial-on' : ''}`}
    >
      <span className="toggle-editorial-knob" aria-hidden />
    </button>
  </div>
);

export const EditorialCheckbox = ({ checked, onChange, label, id, className = '' }) => (
  <label
    htmlFor={id}
    className={`flex items-center gap-3 cursor-pointer py-2 ${className}`}
  >
    <input
      id={id}
      type="checkbox"
      checked={checked}
      onChange={(e) => onChange(e.target.checked)}
      className="checkbox-editorial"
    />
    <span className="text-body text-primary">{label}</span>
  </label>
);

export const EditorialSelect = ({ value, onChange, children, id, className = '' }) => (
  <select
    id={id}
    value={value}
    onChange={onChange}
    className={`select-editorial ${className}`}
  >
    {children}
  </select>
);

export const EditorialSlider = ({ value, onChange, min = 0, max = 10, step = 1, label, id }) => (
  <div className="py-4">
    <div className="flex items-baseline justify-between gap-4 mb-3">
      <p className="text-body text-primary">{label}</p>
      <span className="figure text-h3 text-primary tabular-nums">{value}</span>
    </div>
    <input
      id={id}
      type="range"
      min={min}
      max={max}
      step={step}
      value={value}
      onChange={(e) => onChange(Number(e.target.value))}
      className="slider-editorial w-full"
    />
  </div>
);

export const SegmentedControl = ({ options, value, onChange }) => (
  <div className="flex flex-wrap gap-2">
    {options.map((opt) => {
      const active = value === opt.value;
      return (
        <button
          key={opt.value}
          type="button"
          onClick={() => onChange(opt.value)}
          className={`px-3 py-1.5 rounded-md text-label font-medium border transition-colors duration-300 ${
            active
              ? 'bg-pine-tint border-pine text-pine'
              : 'border-hairline text-secondary hover:text-primary hover:bg-pine-tint/50'
          }`}
        >
          {opt.label}
        </button>
      );
    })}
  </div>
);

export const PortraitFrame = ({ src, alt, initials, size = 'md' }) => {
  const sizes = { xs: 'w-10 h-10', sm: 'w-14 h-14', md: 'w-20 h-20', lg: 'w-24 h-24' };
  const textSizes = { xs: 'text-label', sm: 'text-h3', md: 'text-h2', lg: 'text-h2' };
  return (
    <div
      className={`${sizes[size] || sizes.md} rounded-lg border border-hairline overflow-hidden bg-bone-raised shrink-0 flex items-center justify-center`}
    >
      {src ? (
        <img src={src} alt={alt || ''} className="w-full h-full object-cover aspect-square" />
      ) : (
        <span className={`font-display ${textSizes[size] || textSizes.md} text-primary`}>{initials}</span>
      )}
    </div>
  );
};
